module.exports = __webpack_public_path__ + "static/media/zera_putting_box-min.2813773c.gif";